module.exports = __webpack_public_path__ + "static/media/4ODA18.b4256dc0.jpg";